import React from 'react';
import Icon from './ui/Icon';
import Reveal, { RevealGroup } from './ui/Reveal';
import SectionHeading from './ui/SectionHeading';
import { foundation } from '../data/content';

/** "Our Biblical Foundation" — Ephesians 4:11–12 and what the brief draws from it. */
export default function Foundation() {
  return (
    <section id="foundation" className="on-dark grain relative bg-ink-900 py-24 sm:py-32">
      <div className="shell relative">
        <SectionHeading index="07" label="Foundation" title={foundation.title} lead={foundation.intro} tone="light" />

        <Reveal delay={120} className="mx-auto mt-16 max-w-3xl">
          <figure className="flex gap-6 sm:gap-8">
            <Icon name="quote" className="mt-2 h-9 w-9 shrink-0 text-gold/60 sm:h-11 sm:w-11" />
            <div>
              {/* Set in the serif, not the display caps used elsewhere — a
                  passage this long stops being readable in all caps. */}
              <blockquote className="font-serif text-xl font-light italic leading-[1.55] text-cream/90 sm:text-[1.7rem]">
                {foundation.scripture}
              </blockquote>
              <figcaption className="eyebrow mt-5 text-gold">{foundation.reference}</figcaption>
            </div>
          </figure>
        </Reveal>

        <Reveal as="p" delay={200} className="mx-auto mt-16 max-w-3xl text-center text-base leading-relaxed text-cream/75">
          {foundation.body}
        </Reveal>

        <RevealGroup
          as="ul"
          variant="scale"
          stagger={90}
          delay={120}
          className="mx-auto mt-9 flex max-w-3xl flex-wrap justify-center gap-3"
        >
          {foundation.items.map((item) => (
            <li
              key={item}
              className="border border-cream/15 px-5 py-2.5 font-display text-xs uppercase tracking-[0.14em] text-cream/75 transition-colors duration-500 hover:border-gold hover:text-gold"
            >
              {item}
            </li>
          ))}
        </RevealGroup>

        <Reveal
          as="p"
          delay={200}
          className="mx-auto mt-12 max-w-3xl text-center font-serif text-lg italic leading-relaxed text-gold-300 sm:text-xl"
        >
          {foundation.close}
        </Reveal>
      </div>
    </section>
  );
}
